import axios from "axios";
import { API } from "@/lib/api";

// Separate Bearer instance for patient accounts (token isolated from staff `token`).
export const patientApi = axios.create({ baseURL: API });
patientApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("patient_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function patientErr(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(d);
}
